import React from "react";
import { object } from "prop-types";
import get from "lodash/get";
import { Link } from "@quintype/components";
import assetify from "@quintype/framework/assetify";

import DfpAd from "../../dfp-ad";
import horoscope from "./horoscope.jpg";
import CustomHeadline from "../../molecules/custom-headline";

import "./videos.m.css";

const HoroscopeSingleStory = ({ collection }) => {
  const story = get(collection, ["items", 0, "story"], null);

  return (
    <React.Fragment>
      {story && (
        <div>
          <CustomHeadline text="Horoscope" headerType={10} href={`/${story.slug}`} />
          <Link href={`/${story.slug}`}>
            <div styleName="story-image">
              <img src={` ${assetify(horoscope)}`} alt="Logo" />
            </div>
          </Link>
        </div>
      )}
      {!story && <DfpAd adtype="rectangle_1_300x250" />}
    </React.Fragment>
  );
};

HoroscopeSingleStory.propTypes = {
  collection: object
};

export default HoroscopeSingleStory;
